import { useContext } from 'react';
import { FiSettings } from 'react-icons/fi';
import { BiExit } from 'react-icons/bi';
import { useLogout } from '../../../config/connection/auth';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ROUTE } from '../../../config';
import { SidebarContext } from '../../../providers/SidebarProvider';
import { useReportContext } from '../../../providers/ReportContext';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

function Header() {
    const { isOpen } = useContext(SidebarContext);
    const { isGeneratingReport } = useReportContext();
    const navigate = useNavigate();
    const logout = useLogout();

    const exit = async () => {
        await logout.mutateAsync({});
        navigate(LOGIN_ROUTE);
    }

    const expandedClass: string = isOpen ? '' : '--collapse';

    return (
        <header className={"header"+expandedClass}>
            <div>
                <div>
                    <span className='header-title'>Realiza</span>
                </div>
                <div>
                    {isGeneratingReport && (
                        <div className="report-loading">
                            <AiOutlineLoading3Quarters className="loading-icon" />
                            <span>Gerando relatório...</span>
                        </div>
                    )}
                    <div className='header-section' onClick={exit}>
                        <div><BiExit /></div>
                        <p>Sair</p>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;